"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionStorage = void 0;
var _isSessionStorageSupported = require("../utils/isSessionStorageSupported");
var _singleton = require("../utils/singleton");
var _class;
const isSessionStorageAvailable = (0, _isSessionStorageSupported.isSessionStorageSupported)();
let SessionStorage = exports.SessionStorage = (0, _singleton.singleton)(_class = class SessionStorage {
  getItem(key) {
    if (!(key !== '' && isSessionStorageAvailable)) {
      return null;
    }
    const value = sessionStorage.getItem(key);
    if (value === null) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (error) {
      // NOOP
    }
    return value;
  }
  setItem(key, value) {
    if (key !== '' && isSessionStorageAvailable) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
    return this;
  }
  removeItem(key) {
    if (key !== '' && isSessionStorageAvailable) {
      sessionStorage.removeItem(key);
    }
    return this;
  }
  clearItems(prefix) {
    if (prefix !== '' && isSessionStorageAvailable) {
      Object.keys(sessionStorage).filter(keyName => keyName.indexOf(prefix, 0) === 0).forEach(key => sessionStorage.removeItem(key));
    }
  }
}) || _class;
//# sourceMappingURL=SessionStorage.js.map